import React from "react";
import { toast } from "react-toastify";
import { steps } from "../ModalAutoRenew";
import { GiCheckMark } from "react-icons/gi";
import Spinner from "../../../../components/shared/spinner/Spinner";

const AutoRenew = ({
  initialAutoRenew,
  onClose,
  student,
  user,
  handleAutoRenewal,
  handleCurrentStep,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const autoRenew = async () => {
    try {
      setIsLoading(true);

      await handleAutoRenewal({
        subId: student?.subscription?.id,
        isEnabled: true,
        coachId: user?.id,
      });
      setIsLoading(false);
      handleCurrentStep(steps.ALL_SET);
    } catch (error) {
      toast.error("Failed to auto-renew. Please try again later.");
    }
  };

  return (
    <>
      {!initialAutoRenew && (
        <div className="flex items-center justify-center bg-primary100 w-12 min-w-12 h-12 min-h-12 rounded-full">
          <GiCheckMark className="p-0.5 text-primary700" />
        </div>
      )}

      <div className="text-2xl font-bold text-black mt-2">
        {!initialAutoRenew && (
          <>
            Credit applied! <br />
          </>
        )}
        Do you want {student?.firstName}{" "}
        <span className="uppercase">{student?.lastName?.slice(0, 1)}</span>. to
        auto-renew?
      </div>

      <div className="text-base text-grayTrue700 mt-2">
        By auto-renewing, you will grand 1 credit every month to this student
        from your available student credits
      </div>

      <button
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          autoRenew();
        }}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500 mt-4"
      >
        {isLoading ? (
          <Spinner color="primary500" size="sm" />
        ) : (
          "Yes, auto-renew subscription"
        )}
      </button>

      <button
        disabled={isLoading}
        onClick={onClose}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnGray100 mt-2"
      >
        No thank you
      </button>
    </>
  );
};

export default AutoRenew;
